import React from 'react';
import HamQuest from '../../api/HamQuestGiver';
import { QuestRoute } from '../../api/QuestRoutes';
import PageBreak from '../../layout/PageBreak';
import Input from '../../forms/Input';
import Checkbox from '../../forms/Checkbox';
import Heading from '../../forms/Heading';
import Select from '../../forms/Select';
import { HSOptions } from '../../../constants/HSOptions';
import FormSetting from '../../layout/FormSetting';

const CreditCard = ({ ...props }) => {

    return (
        <PageBreak>
            <FormSetting
                label='Current Processor'
                getInputs={QuestRoute.settings.processor}
                onSubmit={e => HamQuest.put(QuestRoute.settings.processor, e)}
                text='Update'
                name='CurrentProcessor'
                editable
            >
                <Select
                    label='Default Processor'
                    name='processor'
                    options={HSOptions.processors}
                    required
                />
            </FormSetting>


            <FormSetting
                label='E-xact / E-xact Hosted'
                name='ExactSettings'
                getInputs={QuestRoute.settings.exact}
                onSubmit={e => HamQuest.put(QuestRoute.settings.exact, e)}
                text='Update'
                editable
                autoComplete='off'
            >

                <Heading>E-xact</Heading>
                <Input
                    label='Gateway ID'
                    name='exactId'
                />
                <Input
                    label='Password'
                    name='exactPassword'
                    type='password'
                    autoComplete='off'
                />
                <Heading>E-xact Hosted</Heading>
                <Input
                    label='Payment Page ID'
                    name='exactHostedLogin'
                />
                <Input
                    label='Transaction Key'
                    name='exactHostedKey'
                />
            </FormSetting>

            <FormSetting
                label='Moneris'
                name='MonerisSettings'
                getInputs={QuestRoute.settings.moneris}
                onSubmit={e => HamQuest.put(QuestRoute.settings.moneris, e)}
                text='Update'
                editable
                autoComplete='off'
            >
                <Input
                    label='PreAuth Store Id'
                    name='monerisPreAuthStoreId'
                />
                <Input
                    label='PreAuth Hpp Key'
                    name='monerisPreAuthHppKey'
                    type='password'
                    autoComplete='off'
                />
                <Input
                    label='Purchase Store Id'
                    name='monerisPurchaseStoreId'
                />
                <Input
                    label='Purchase Hpp Key'
                    name='monerisPurchaseHppKey'
                    type='password'
                    autoComplete='off'
                />
                <Input
                    label='API Store Id'
                    name='monerisApiStoreId'
                />
                <Input
                    label='API Token'
                    name='monerisApiToken'
                    type='password'
                    autoComplete='off'
                />
                <Input
                    label='Card verification ID'
                    name='monerisCardVerificationCheckoutId'
                />
                <Input
                    label='Checkout ID'
                    name='monerisPreauthCheckoutId'
                />
            </FormSetting>

            <FormSetting
                label='WorldPay'
                name='WorldPaySettings'
                getInputs={QuestRoute.settings.worldPay}
                onSubmit={e => HamQuest.put(QuestRoute.settings.worldPay, e)}
                text='Update'
                editable
                autoComplete='off'
            >
                {({ values }) => (
                    <>
                        <Input
                            label='Account ID'
                            name='worldpayAccountId'
                        />
                        <Input
                            label='Account Token'
                            name='worldpayAccountToken'
                            type='password'
                            autoComplete='off'
                        />
                        <Input
                            label='Acceptor ID'
                            name='worldpayAcceptorId'
                        />

                        <Heading>Auto Updater</Heading>
                        <Checkbox
                            label='Account Auto Updater'
                            name='worldpayAccountUpdater'
                        />
                        <Checkbox
                            label='Grace Period Enabled'
                            name='worldpayAccountUpdaterGracePeriod'
                        />
                        <Input
                            label='Grace Period Days'
                            name='worldpayAccountUpdaterGracePeriodDays'
                            type='number'
                            min={0}
                            required
                            disable={!values.worldpayAccountUpdaterGracePeriod}
                        />

                    </>)}
            </FormSetting>

            <FormSetting
                label='ID TECH'
                name='IDTechSettings'
                getInputs={QuestRoute.settings.IDTech}
                onSubmit={e => HamQuest.put(QuestRoute.settings.IDTech, { ...e })}
                text='Update'
                editable
                autoComplete='off'
            >
                <Input
                    label='Account ID'
                    name='worldpayAccountId'
                    required
                />
                <Input
                    label='Account Token'
                    name='worldpayAccountToken'
                    type='password'
                    autoComplete='off'
                    required
                />
                <Input
                    label='Acceptor ID'
                    name='worldpayAcceptorId'
                    required
                />
                <Input
                    label='License'
                    name='license'
                    required
                />
            </FormSetting>
        </PageBreak>
    );
}

export default CreditCard;